/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DocumentType {

    CpitBeratung = 'CpitBeratung',

    CpitVorschlag = 'CpitVorschlag',

    InsurerOffer = 'InsurerOffer',

    InsurerContract = 'InsurerContract',

    InsurerSepa = 'InsurerSepa',

    InsurerProductInformation = 'InsurerProductInformation',

    InsurerOther = 'InsurerOther',

    EsgIdd = 'EsgIdd',

    CpitDeckungsnote = 'CpitDeckungsnote',

    InsurerXml = 'InsurerXml',

    CpitEvb = 'CpitEvb',

    CpitKuendigungVorversicherung = 'CpitKuendigungVorversicherung',

    CpitVergleich = 'CpitVergleich',

    Antragsdaten = 'Antragsdaten'
}

